import { render, staticRenderFns } from "./NewsArticleBlock.vue?vue&type=template&id=73be06da&scoped=true"
import script from "./NewsArticleBlock.vue?vue&type=script&lang=js"
export * from "./NewsArticleBlock.vue?vue&type=script&lang=js"
import style0 from "./NewsArticleBlock.vue?vue&type=style&index=0&id=73be06da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be06da",
  null
  
)

export default component.exports